/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ProtectRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {ProtectResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const protect = (request: ProtectRequest, options?: CashRequestOptions) => post<ProtectRequest, ProtectResponse>("/2.0/cash/protect", request, {...options, rejectOnError: true })